module.exports = __webpack_public_path__ + "static/media/location-ico.7d830c9f.svg";